import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import { HOME_MICRIO_ID, PAGES } from '@/config/pages'

// Every route declares which Micrio image it shows. The persistent
// <MicrioViewer> in App.vue reads this, so the URL is the single source
// of truth for what's on screen (incl. deep links and browser back).
declare module 'vue-router' {
	interface RouteMeta {
		micrioId?: string
		//  Skip mounting the Micrio viewer — for pages that own the whole screen. Only applies to testing pages like /styleguide
		standalone?: boolean
	}
}

const routes: Array<RouteRecordRaw> = [
	{
		path: '/',
		name: 'home',
		component: HomeView,
		meta: { micrioId: HOME_MICRIO_ID },
	},
	{
		path: '/onderbouw',
		name: 'onderbouw',
		component: () => import('../views/detail/OnderbouwView.vue'),
		meta: { micrioId: PAGES.onderbouw.micrioId },
	},
	{
		path: '/middenbouw',
		name: 'middenbouw',
		component: () => import('../views/detail/MiddenbouwView.vue'),
		meta: { micrioId: PAGES.middenbouw.micrioId },
	},
	{
		path: '/bovenbouw',
		name: 'bovenbouw',
		component: () => import('../views/detail/BovenbouwView.vue'),
		meta: { micrioId: PAGES.bovenbouw.micrioId },
	},
	{
		path: '/styleguide',
		name: 'styleguide',
		component: () => import('../views/StyleguideView.vue'),
		meta: { standalone: true },
	},
]

const router = createRouter({
	history: createWebHashHistory(process.env.BASE_URL),
	routes,
})

export default router
